import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { headerHeight } from 'components/Header/Header';

const AppBodyContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  minHeight: `calc(100vh - ${headerHeight}px - 1px)`,
  marginLeft: 'auto',
  marginRight: 'auto',
  boxSizing: 'border-box',
  display: 'block',
  padding: '24px 0',
  maxWidth: '1152px',
  [theme.breakpoints.between('xs', 'sm')]: {
    width: '343px',
  },
  [theme.breakpoints.between('sm', 'lg')]: {
    width: '688px',
  },
  [theme.breakpoints.between('lg', 'xl')]: {
    width: '763px',
  },
  [theme.breakpoints.up('xl')]: {
    width: '1152px',
  },
}));

export default AppBodyContainer;
